import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Select } from 'antd';
import { useCompleteOnboarding } from '../api/profileApi';
import { COUNTRIES } from '../constants/countries';
import { AGE_RANGES, SEX_OPTIONS, EDUCATION_LEVELS } from '../constants/onboarding';

const countryOptions = COUNTRIES.map((country) => ({ value: country, label: country }));
const ageRangeOptions = AGE_RANGES.map((range) => ({ value: range, label: range }));
const educationOptions = EDUCATION_LEVELS.map((level) => ({ value: level, label: level }));

const Onboarding = () => {
  const [country, setCountry] = useState('');
  const [ageRange, setAgeRange] = useState('');
  const [sex, setSex] = useState('');
  const [education, setEducation] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { mutateAsync, isPending } = useCompleteOnboarding();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!country) {
      setError('Please select your country');
      return;
    }

    setError('');
    try {
      await mutateAsync({
        country,
        answers: {
          ageRange: ageRange || undefined,
          sex: sex || undefined,
          education: education || undefined,
        },
      });
      navigate('/');
    } catch (err) {
      setError(err?.response?.data?.error || 'Something went wrong, please try again');
    }
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
        <div>
          <h2 className="text-2xl font-bold text-center mb-2">Just a couple more things</h2>
          <span className="text-center text-base text-gray-500 block mt-0">
            Help us tailor and improve your experience.
          </span>
        </div>

        {error && (
          <p className="text-center text-sm text-red-600">{error}</p>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="country" className="block text-sm font-medium text-gray-700">
              Country <span className="text-red-500">*</span>
            </label>
            <Select
              id="country"
              className="w-full mt-1"
              showSearch
              placeholder="Select your country"
              optionFilterProp="label"
              value={country || undefined}
              onChange={setCountry}
              options={countryOptions}
            />
          </div>

          <div>
            <label htmlFor="ageRange" className="block text-sm font-medium text-gray-700">
              Age range <span className="text-gray-400">(optional)</span>
            </label>
            <Select
              id="ageRange"
              className="w-full mt-1"
              allowClear
              placeholder="Select your age range"
              value={ageRange || undefined}
              onChange={(value) => setAgeRange(value || '')}
              options={ageRangeOptions}
            />
          </div>

          <div>
            <label htmlFor="sex" className="block text-sm font-medium text-gray-700">
              Sex <span className="text-gray-400">(optional)</span>
            </label>
            <Select
              id="sex"
              className="w-full mt-1"
              allowClear
              placeholder="Select your sex"
              value={sex || undefined}
              onChange={(value) => setSex(value || '')}
              options={SEX_OPTIONS}
            />
          </div>

          <div>
            <label htmlFor="education" className="block text-sm font-medium text-gray-700">
              Highest educational qualification <span className="text-gray-400">(optional)</span>
            </label>
            <Select
              id="education"
              className="w-full mt-1"
              allowClear
              placeholder="Select your highest qualification"
              value={education || undefined}
              onChange={(value) => setEducation(value || '')}
              options={educationOptions}
            />
          </div>

          <button
            type="submit"
            disabled={isPending}
            className="w-full bg-primary text-white py-2 rounded-lg hover:bg-primary-dark transition duration-300 font-bold"
          >
            {isPending ? 'Saving...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Onboarding;

